import { createGlobalStyle } from "styled-components";
import theme from './theme';
import { RelSize } from "./mixins";
import { HelpWrapperStyled } from "./forms/inputs";

export const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'Poppins';
        font-style: italic;
        font-weight: 400;
        font-display: swap;
        src: url("https://fonts.gstatic.com/s/montserrat/v15/JTUQjIg1_i6t8kCHKm459WxRyS7m0dR9pA.woff2") format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
	/* latin */
	@font-face {
		font-family: 'Poppins';
		font-style: italic;
		font-weight: 400;
		font-display: swap;
		src: url("https://fonts.gstatic.com/s/poppins/v15/pxiGyp8kv8JHgFVrJJLucHtAOvWDSA.woff2") format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}
	/* latin */
	@font-face {
		font-family: 'Poppins';
		font-style: normal;
		font-weight: 300;
		font-display: swap;
		src: url("https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLDz8Z1xlFd2JQEk.woff2") format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}
	/* latin */
	@font-face {
		font-family: 'Poppins';
		font-style: normal;
		font-weight: 400;
		font-display: swap;
		src: url("https://fonts.gstatic.com/s/poppins/v15/pxiEyp8kv8JHgFVrJJfecnFHGPc.woff2") format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}
	/* latin */
	@font-face {
		font-family: 'Poppins';
		font-style: normal;
		font-weight: 600;
		font-display: swap;
		src: url("https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLEj6Z1xlFd2JQEk.woff2") format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}
	/* latin */
	@font-face {
		font-family: 'Poppins';
		font-style: normal;
		font-weight: 700;
		font-display: swap;
		src: url("https://fonts.gstatic.com/s/poppins/v15/pxiByp8kv8JHgFVrLCz7Z1xlFd2JQEk.woff2") format('woff2');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}

	*, *:before, *:after {
        box-sizing: border-box;
    }

    html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}

    body {
        background-color: ${theme.backgroundGrey};
        font-family: 'Source Sans Pro', sans-serif;
        color: ${theme.black};
        font-weight: 300;
        @media (min-width: 481px) and (max-width: 1024px) {
            font-size: calc(14px + 2 * ((100vw - 480px) / 544));
        }
        @media screen and (min-width: 1024px) {
            font-size: 16px;
        }
        @media screen and (max-width: 480px) {
            font-size: 14px;
        }
    }

    a {
        color: ${theme.black};
        cursor: pointer;
        font-weight: 400;
        text-decoration: none;
        transition: all ease-in 0.2s;
		&.anchor-highlight {
			font-weight: 700;
			text-decoration: underline;
		}
    }

    p {
        margin-top: 0;
    }

	.ReactModalPortal {
		position: relative;
		z-index: 9999;
	}

	.rbc-overlay {
    position: absolute;
    z-index: 5;
    border: 1px solid #e5e5e5;
    background-color: #fff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
	border-radius: 5px;
    padding: 10px;
    max-height: 350px;
    overflow-y: auto;
	scrollbar-width: thin;
	scrollbar-color: ${theme.primaryGreen} transparent;
	&::-webkit-scrollbar {
	  width: 5px;
	}
	&::-webkit-scrollbar-track {
	  background: transparent;
	}
	&::-webkit-scrollbar-thumb {
	  background: ${theme.primaryGreen};
	}
	z-index: 999;
        .rbc-event {
			background-color: ${theme.quarterinaryGreen};
			border-radius: 5px;
			color: #ffffff;
			cursor: pointer;
            font-size: 11px;
			margin-bottom: 5px;
			padding: 0;
			overflow: hidden;
			.event-detail {
				display: flex;
				font-size: 11px;
				height: 38px;
				line-height: 12px;
				padding: 7px 20px 6px 5px;
				max-width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				&-tuition {
					padding-bottom: 1px;
					padding-top: 1px;
				}
				span {
					display: block;
					&.event-detail-title {
						font-weight: 400;
					}
				}
				.event-detail-pr {
					align-items: flex-end;
					display: flex;
					flex-direction: column;
				}
				&.hasTimesheet {
					padding-right: ${RelSize(20, 11)} !important;
					position: relative;
					&::after {
						background-color: ${props => props.theme.primaryGreen};
						bottom: 0;
						content: "";
						position: absolute;
						right: 0;
						top: 0;
						width: ${RelSize(20, 11)};
					}
					&.timesheetApproved {
						&::after {
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0iR3JvdXBfOTUxNiIgZGF0YS1uYW1lPSJHcm91cCA5NTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQyLjk1OCAtNjkyOS41MDIpIj4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTk3IiBkYXRhLW5hbWU9IkVsbGlwc2UgMTk3IiBjeD0iOCIgY3k9IjgiIHI9IjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0My45NTggNjkzMC41MDIpIiBmaWxsPSJub25lIiBzdHJva2U9IiMxZGFkN2UiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTA2MjgiIGRhdGEtbmFtZT0iUGF0aCAxMDYyOCIgZD0iTTI1Ny45NTgsNjkzOC4wNjZ2My42NzJsMy4yODYsMy42NzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02LjI3NiAtMy4zOTEpIiBmaWxsPSJub25lIiBzdHJva2U9IiMxZGFkN2UiIHN0cm9rZS13aWR0aD0iMiIvPgogIDwvZz4KPC9zdmc+Cg==");
							background-repeat: no-repeat;
							background-position: right 2px top 50%;
							background-size: 16px;
						}
					}
					&.timesheetRejected {
						&::after {
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0iR3JvdXBfOTUxNiIgZGF0YS1uYW1lPSJHcm91cCA5NTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQyLjk1OCAtNjkyOS41MDIpIj4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTk3IiBkYXRhLW5hbWU9IkVsbGlwc2UgMTk3IiBjeD0iOCIgY3k9IjgiIHI9IjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0My45NTggNjkzMC41MDIpIiBmaWxsPSJub25lIiBzdHJva2U9IiNlMjMxNDEiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTA2MjgiIGRhdGEtbmFtZT0iUGF0aCAxMDYyOCIgZD0iTTI1Ny45NTgsNjkzOC4wNjZ2My42NzJsMy4yODYsMy42NzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02LjI3NiAtMy4zOTEpIiBmaWxsPSJub25lIiBzdHJva2U9IiNlMjMxNDEiIHN0cm9rZS13aWR0aD0iMiIvPgogIDwvZz4KPC9zdmc+Cg==");
							background-repeat: no-repeat;
							background-position: right 2px top 50%;
							background-size: 16px;
						}
					}
					&.timesheetPending {
						&::after {
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBpZD0iR3JvdXBfOTUxNiIgZGF0YS1uYW1lPSJHcm91cCA5NTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQyLjk1OCAtNjkyOS41MDIpIj4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTk3IiBkYXRhLW5hbWU9IkVsbGlwc2UgMTk3IiBjeD0iOCIgY3k9IjgiIHI9IjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0My45NTggNjkzMC41MDIpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmNWJjMDAiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTA2MjgiIGRhdGEtbmFtZT0iUGF0aCAxMDYyOCIgZD0iTTI1Ny45NTgsNjkzOC4wNjZ2My42NzJsMy4yODYsMy42NzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02LjI3NiAtMy4zOTEpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmNWJjMDAiIHN0cm9rZS13aWR0aD0iMiIvPgogIDwvZz4KPC9zdmc+Cg==");
							background-repeat: no-repeat;
							background-position: right 2px top 50%;
							background-size: 16px;
						}
					}
					&.pendingLeftApprovedRight {
						&::after {
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjAuNSIgeDI9IjAuNSIgeTI9IjAuOTczIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2Y1YmMwMCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuNDg4IiBzdG9wLWNvbG9yPSIjZjViYzAwIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMC41MTciIHN0b3AtY29sb3I9IiNjM2I5MWQiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMWRhZDdlIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfOTUxNiIgZGF0YS1uYW1lPSJHcm91cCA5NTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQxLjk1OCAtNjkwNC41MDIpIj4KICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8yIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDIiIGQ9Ik0xMTkuOTU4LDUxOTkuNWE5LDksMCwxLDEsOS05QTkuMDEsOS4wMSwwLDAsMSwxMTkuOTU4LDUxOTkuNVptMC0xNmE3LDcsMCwxLDAsNyw3QTcuMDA4LDcuMDA4LDAsMCwwLDExOS45NTgsNTE4My41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ5MzkuNTQzIDcwMzMuNDYpIHJvdGF0ZSgtOTApIiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudCkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEwNzE4IiBkYXRhLW5hbWU9IlBhdGggMTA3MTgiIGQ9Ik0yNTcuOTU4LDY5MzguMDY2djMuNjcybDMuMjg2LDMuNjcyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNyAtMjguMjM2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjN2M3YzdjIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo=");
							background-repeat: no-repeat;
							background-position: right 2px top 50%;
							background-size: 16px;
						}
					}
					&.approvedLeftPendingRight {
						&::after {
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjAuNSIgeDI9IjAuNSIgeTI9IjAuOTczIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzFkYWQ3ZSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuNDg4IiBzdG9wLWNvbG9yPSIjMWRhZDdlIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMC41MTciIHN0b3AtY29sb3I9IiNmNWJjMDAiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZjViYzAwIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfOTUxNiIgZGF0YS1uYW1lPSJHcm91cCA5NTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQxLjk1OCAtNjkwNC41MDIpIj4KICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8yIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDIiIGQ9Ik0xMTkuOTU4LDUxOTkuNWE5LDksMCwxLDEsOS05QTkuMDEsOS4wMSwwLDAsMSwxMTkuOTU4LDUxOTkuNVptMC0xNmE3LDcsMCwxLDAsNyw3QTcuMDA4LDcuMDA4LDAsMCwwLDExOS45NTgsNTE4My41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ5MzkuNTQzIDcwMzMuNDYpIHJvdGF0ZSgtOTApIiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudCkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEwNzE4IiBkYXRhLW5hbWU9IlBhdGggMTA3MTgiIGQ9Ik0yNTcuOTU4LDY5MzguMDY2djMuNjcybDMuMjg2LDMuNjcyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNyAtMjguMjM2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjN2M3YzdjIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo=");
							background-repeat: no-repeat;
							background-position: right 2px top 50%;
							background-size: 16px;
						}
					}
					&.approvedLeftRejectedRight {
						&::after {
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjAuNSIgeDI9IjAuNSIgeTI9IjAuOTczIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzFkYWQ3ZSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuNDg4IiBzdG9wLWNvbG9yPSIjMWRhZDdlIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMC41MTciIHN0b3AtY29sb3I9IiNlMjMxNDEiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZTIzMTQxIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfOTUxNiIgZGF0YS1uYW1lPSJHcm91cCA5NTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQxLjk1OCAtNjkwNC41MDIpIj4KICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8yIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDIiIGQ9Ik0xMTkuOTU4LDUxOTkuNWE5LDksMCwxLDEsOS05QTkuMDEsOS4wMSwwLDAsMSwxMTkuOTU4LDUxOTkuNVptMC0xNmE3LDcsMCwxLDAsNyw3QTcuMDA4LDcuMDA4LDAsMCwwLDExOS45NTgsNTE4My41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ5MzkuNTQzIDcwMzMuNDYpIHJvdGF0ZSgtOTApIiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudCkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEwNzE4IiBkYXRhLW5hbWU9IlBhdGggMTA3MTgiIGQ9Ik0yNTcuOTU4LDY5MzguMDY2djMuNjcybDMuMjg2LDMuNjcyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNyAtMjguMjM2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjN2M3YzdjIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo=");
							background-repeat: no-repeat;
							background-position: right 2px top 50%;
							background-size: 16px;
						}
					}
					&.rejectedLeftApprovedRight {
						&::after {
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjAuNSIgeDI9IjAuNSIgeTI9IjAuOTczIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2UyMzE0MSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuNDg4IiBzdG9wLWNvbG9yPSIjZTIzMTQxIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMC41MTciIHN0b3AtY29sb3I9IiMxZGFkN2UiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMWRhZDdlIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfOTUxNiIgZGF0YS1uYW1lPSJHcm91cCA5NTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQxLjk1OCAtNjkwNC41MDIpIj4KICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8yIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDIiIGQ9Ik0xMTkuOTU4LDUxOTkuNWE5LDksMCwxLDEsOS05QTkuMDEsOS4wMSwwLDAsMSwxMTkuOTU4LDUxOTkuNVptMC0xNmE3LDcsMCwxLDAsNyw3QTcuMDA4LDcuMDA4LDAsMCwwLDExOS45NTgsNTE4My41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ5MzkuNTQzIDcwMzMuNDYpIHJvdGF0ZSgtOTApIiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudCkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEwNzE4IiBkYXRhLW5hbWU9IlBhdGggMTA3MTgiIGQ9Ik0yNTcuOTU4LDY5MzguMDY2djMuNjcybDMuMjg2LDMuNjcyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNyAtMjguMjM2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjN2M3YzdjIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo=");
							background-repeat: no-repeat;
							background-position: right 2px top 50%;
							background-size: 16px;
						}
					}
					&.pendingLeftRejectedRight {
						&::after {
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjAuNSIgeDI9IjAuNSIgeTI9IjAuOTczIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2Y1YmMwMCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuNDg4IiBzdG9wLWNvbG9yPSIjZjViYzAwIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMC41MTciIHN0b3AtY29sb3I9IiNlMjMxNDEiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZTIzMTQxIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfOTUxNiIgZGF0YS1uYW1lPSJHcm91cCA5NTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQxLjk1OCAtNjkwNC41MDIpIj4KICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8yIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDIiIGQ9Ik0xMTkuOTU4LDUxOTkuNWE5LDksMCwxLDEsOS05QTkuMDEsOS4wMSwwLDAsMSwxMTkuOTU4LDUxOTkuNVptMC0xNmE3LDcsMCwxLDAsNyw3QTcuMDA4LDcuMDA4LDAsMCwwLDExOS45NTgsNTE4My41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ5MzkuNTQzIDcwMzMuNDYpIHJvdGF0ZSgtOTApIiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudCkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEwNzE4IiBkYXRhLW5hbWU9IlBhdGggMTA3MTgiIGQ9Ik0yNTcuOTU4LDY5MzguMDY2djMuNjcybDMuMjg2LDMuNjcyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNyAtMjguMjM2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjN2M3YzdjIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo=");
							background-repeat: no-repeat;
							background-position: right 3px top 50%;
							background-size: 16px;
						}
					}
					&.rejectedLeftPendingRight {
						&::after {
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjAuNSIgeDI9IjAuNSIgeTI9IjAuOTczIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2UyMzE0MSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuNDg4IiBzdG9wLWNvbG9yPSIjZTIzMTQxIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMC41MTciIHN0b3AtY29sb3I9IiNmNWJjMDAiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZjViYzAwIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfOTUxNiIgZGF0YS1uYW1lPSJHcm91cCA5NTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQxLjk1OCAtNjkwNC41MDIpIj4KICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8yIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDIiIGQ9Ik0xMTkuOTU4LDUxOTkuNWE5LDksMCwxLDEsOS05QTkuMDEsOS4wMSwwLDAsMSwxMTkuOTU4LDUxOTkuNVptMC0xNmE3LDcsMCwxLDAsNyw3QTcuMDA4LDcuMDA4LDAsMCwwLDExOS45NTgsNTE4My41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ5MzkuNTQzIDcwMzMuNDYpIHJvdGF0ZSgtOTApIiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudCkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEwNzE4IiBkYXRhLW5hbWU9IlBhdGggMTA3MTgiIGQ9Ik0yNTcuOTU4LDY5MzguMDY2djMuNjcybDMuMjg2LDMuNjcyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNyAtMjguMjM2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjN2M3YzdjIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo=");
							background-repeat: no-repeat;
							background-position: right 3px top 50%;
							background-size: 16px;
						}
					}
				}
				&.bookingDayInactive {
					padding-right: ${RelSize(20, 11)} !important;
					position: relative;
					&::after {
						background-color: ${props => props.theme.red};
						bottom: 0;
						content: "";
						position: absolute;
						right: 0;
						top: 0;
						width: ${RelSize(20, 11)};
					}
					&.bookingDayActofGod, &.bookingDayCancelled, &.bookingDayNoShow, &.bookingDaySickness, &.bookingDayPersonalAppt {
						&::after {
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NjkuOTMxIiBoZWlnaHQ9IjQ2OS45MzEiIHZpZXdCb3g9IjAgMCA0NjkuOTMxIDQ2OS45MzEiPgogIDxwYXRoIGlkPSJlcnJvci1zdmdyZXBvLWNvbSIgZD0iTTIzNC45NjYsMEMxMDUuMTg0LDAsMCwxMDUuMTg0LDAsMjM0Ljk2NlMxMDUuMTg0LDQ2OS45MzEsMjM0Ljk2Niw0NjkuOTMxLDQ2OS45MzEsMzY0Ljc0OCw0NjkuOTMxLDIzNC45NjYsMzY0Ljc0OCwwLDIzNC45NjYsMFpNNTguNzQxLDIzNC45NjZBMTc2LjAxOCwxNzYuMDE4LDAsMCwxLDMzOC4zMTQsOTIuNDI2TDkyLjQyNiwzMzguMzE0QTE3NS4wODIsMTc1LjA4MiwwLDAsMSw1OC43NDEsMjM0Ljk2NlpNMjM0Ljk2Niw0MTEuMTlhMTc1LjA4MiwxNzUuMDgyLDAsMCwxLTEwMy4zNDgtMzMuNjg1TDM3Ny41MDUsMTMxLjYxN0ExNzYuMDE4LDE3Ni4wMTgsMCwwLDEsMjM0Ljk2Niw0MTEuMTlaIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo=");
							background-repeat: no-repeat;
							background-position: right 2px top 50%;
							background-size: 16px;
						}
					}
				}
				&.bookingSplit {
					padding-right: ${RelSize(25, 11)} !important;
					position: relative;
					&::after {
						background-color: ${props => props.theme.primaryGreen};
						background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0icGVyY2VudC1jaXJjbGUtc3ZncmVwby1jb20iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yIC0yKSI+CiAgICA8cGF0aCBpZD0iUGF0aF8xIiBkYXRhLW5hbWU9IlBhdGggMSIgZD0iTTE2LDgsOCwxNiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMiIgZGF0YS1uYW1lPSJQYXRoIDIiIGQ9Ik05LDkuMDFWOSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMyIgZGF0YS1uYW1lPSJQYXRoIDMiIGQ9Ik0xNSwxNS4wMVYxNSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfNCIgZGF0YS1uYW1lPSJQYXRoIDQiIGQ9Ik0yMSwxMmE5LDksMCwxLDEtOS05QTksOSwwLDAsMSwyMSwxMloiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgPC9nPgo8L3N2Zz4K");
						background-repeat: no-repeat;
						background-position: right 2px top 50%;
						background-size: 20px;
						bottom: 0;
						content: "";
						position: absolute;
						right: 0;
						top: 0;
						width: ${RelSize(25, 11)};
					}
				}
				&.bookingInterview {
					padding-right: ${RelSize(20, 11)} !important;
					position: relative;
					&::after {
						background-color: ${props => props.theme.primaryGreen};
						background-image: url("data:image/svg+xml;base64,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");
						background-repeat: no-repeat;
						background-position: right 2px top 50%;
						background-size: 15px;
						bottom: 0;
						content: "";
						position: absolute;
						right: 0;
						top: 0;
						width: ${RelSize(20, 11)};
					}
				}
				&.bookingInterviewFaceToFace {
					padding-right: ${RelSize(20, 11)} !important;
					position: relative;
					&::after {
						background-color: ${props => props.theme.primaryGreen};
						background-image: url("data:image/svg+xml;base64,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");
						background-repeat: no-repeat;
						background-position: right 1px top 50%;
						background-size: 18px;
						bottom: 0;
						content: "";
						position: absolute;
						right: 0;
						top: 0;
						width: ${RelSize(20, 11)};
					}
				}
				&.bookingTrial {
					padding-right: ${RelSize(20, 11)} !important;
					position: relative;
					&::after {
						background-color: ${props => props.theme.primaryGreen};
						background-image: url("data:image/svg+xml;base64,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");
						background-repeat: no-repeat;
						background-position: right 2px top 50%;
						background-size: 15px;
						bottom: 0;
						content: "";
						position: absolute;
						right: 0;
						top: 0;
						width: ${RelSize(20, 11)};
					}
				}
				&.bookingPerm {
					padding-right: ${RelSize(20, 11)} !important;
					position: relative;
					&::after {
						background-color: ${props => props.theme.primaryGreen};
						background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTYgOCI+CiAgPGcgaWQ9ImxheWVyMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNi4wMjUgLTEwNDIuMSkiPgogICAgPHBhdGggaWQ9InBhdGgxMTQyIiBkPSJNLTIuMDI1LDEwNDIuMWE0LDQsMCwwLDAtNCw0LDQsNCwwLDAsMCw0LDRjMiwwLDQtMSw1LTRDMS45NzUsMTA0My4xLS4wMjUsMTA0Mi4xLTIuMDI1LDEwNDIuMVptMCwyYTMuNTUyLDMuNTUyLDAsMCwxLDMsMiwzLjU1MiwzLjU1MiwwLDAsMS0zLDIsMiwyLDAsMCwxLTItMkEyLDIsMCwwLDEtMi4wMjUsMTA0NC4xWiIgZmlsbD0iI2ZmZiIvPgogICAgPHBhdGggaWQ9InBhdGgxMTQyLTMiIGQ9Ik01Ljk3NSwxMDQyLjFhNCw0LDAsMSwxLDAsOGMtMiwwLTQtMS01LTRDMS45NzUsMTA0My4xLDMuOTc1LDEwNDIuMSw1Ljk3NSwxMDQyLjFabTAsMmEyLjE2NywyLjE2NywwLDEsMCwwLDQsMiwyLDAsMCwwLDAtNFoiIGZpbGw9IiNmZmYiLz4KICA8L2c+Cjwvc3ZnPgo=");
						background-repeat: no-repeat;
						background-position: right 2px top 50%;
						background-size: 15px;
						bottom: 0;
						content: "";
						position: absolute;
						right: 0;
						top: 0;
						width: ${RelSize(20, 11)};
					}
				}
				&.bookingTuition {
					padding-right: ${RelSize(20, 11)} !important;
					position: relative;
					&::after {
						background-color: ${props => props.theme.primaryGreen};
						background-image: url("data:image/svg+xml;base64,PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPCEtLSBVcGxvYWRlZCB0bzogU1ZHIFJlcG8sIHd3dy5zdmdyZXBvLmNvbSwgVHJhbnNmb3JtZWQgYnk6IFNWRyBSZXBvIE1peGVyIFRvb2xzIC0tPgo8c3ZnIGhlaWdodD0iODAwcHgiIHdpZHRoPSI4MDBweCIgdmVyc2lvbj0iMS4xIiBpZD0iSWNvbnMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgZmlsbD0iI2ZmZmZmZiIgc3Ryb2tlPSIjZmZmZmZmIj4KDTxnIGlkPSJTVkdSZXBvX2JnQ2FycmllciIgc3Ryb2tlLXdpZHRoPSIwIi8+Cg08ZyBpZD0iU1ZHUmVwb190cmFjZXJDYXJyaWVyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KDTxnIGlkPSJTVkdSZXBvX2ljb25DYXJyaWVyIj4gPHN0eWxlIHR5cGU9InRleHQvY3NzIj4gLnN0MHtmaWxsOiNGRkZGRkY7fSA8L3N0eWxlPiA8Zz4gPHBhdGggZD0iTTMxLDI2Yy0wLjYsMC0xLTAuNC0xLTFWMTJjMC0wLjYsMC40LTEsMS0xczEsMC40LDEsMXYxM0MzMiwyNS42LDMxLjYsMjYsMzEsMjZ6Ii8+IDwvZz4gPGc+IDxwYXRoIGQ9Ik0xNiwyMWMtMC4yLDAtMC4zLDAtMC41LTAuMWwtMTUtOEMwLjIsMTIuNywwLDEyLjQsMCwxMnMwLjItMC43LDAuNS0wLjlsMTUtOGMwLjMtMC4yLDAuNi0wLjIsMC45LDBsMTUsOCBjMC4zLDAuMiwwLjUsMC41LDAuNSwwLjlzLTAuMiwwLjctMC41LDAuOWwtMTUsOEMxNi4zLDIxLDE2LjIsMjEsMTYsMjF6Ii8+IDwvZz4gPHBhdGggZD0iTTE3LjQsMjIuNkMxNywyMi45LDE2LjUsMjMsMTYsMjNzLTEtMC4xLTEuNC0wLjRMNiwxOC4xVjIyYzAsMy4xLDQuOSw2LDEwLDZzMTAtMi45LDEwLTZ2LTMuOUwxNy40LDIyLjZ6Ii8+IDwvZz4KDTwvc3ZnPg==");
						background-repeat: no-repeat;
						background-position: right 2px top 50%;
						background-size: 15px;
						bottom: 0;
						content: "";
						position: absolute;
						right: 0;
						top: 0;
						width: ${RelSize(20, 11)};
					}
				}
			}
        }
		.rbc-overlay-header {
			font-size: 12px;
		}
    }
    .rbc-overlay > * + * {
    margin-top: 1px;
    }

    .rbc-overlay-header {
        border-bottom: 1px solid #e5e5e5;
        font-size: 12px;
		font-weight: 700;
        margin: -10px -10px 5px -10px;
        padding: 10px;
    }

    #nprogress {
        pointer-events: none;
    }

    #nprogress .bar {
        background: ${theme.primaryGreen};
        position: fixed;
        z-index: 1031;
        top: 0;
        left: 0;
        width: 100%;
        height: 2px;
    }

    #nprogress .peg {
        display: block;
        position: absolute;
        right: 0px;
        width: 100px;
        height: 100%;
        box-shadow: 0 0 5px ${theme.primaryGreen}, 0 0 5px ${theme.primaryGreen};
        opacity: 1.0;
        -webkit-transform: rotate(3deg) translate(0px, -4px);
            -ms-transform: rotate(3deg) translate(0px, -4px);
                transform: rotate(3deg) translate(0px, -4px);
    }

    #nprogress .spinner {
        display: block;
        position: fixed;
        z-index: 1031;
        top: 10px;
        right: 15px;
    }

    #nprogress .spinner-icon {
        width: 18px;
        height: 18px;
        box-sizing: border-box;border: solid 2px transparent;
        border-top-color: ${theme.primaryGreen};
        border-left-color: ${theme.primaryGreen};
        border-radius: 50%;
        -webkit-animation: nprogress-spinner 400ms linear infinite;
                animation: nprogress-spinner 400ms linear infinite;
    }

    .nprogress-custom-parent {
        overflow: hidden;
        position: relative;
    }

    .nprogress-custom-parent #nprogress .spinner,
    .nprogress-custom-parent #nprogress .bar {
        position: absolute;
    }

	#helpModalParent {
		position: relative;
		z-index: 999999;
	}

    @-webkit-keyframes nprogress-spinner {
        0%   { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes nprogress-spinner {
        0%   { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    @-webkit-keyframes alert-progress {
		0%   { width: 0 }
		100% { width: 100% }
	}
	@keyframes alert-progress {
		0%   { width: 0 }
		100% { width: 100% }
	}
    @-webkit-keyframes loading {
        0%   { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }
    @keyframes loading {
        0%   { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
	@keyframes button-loading-spinner {
		from {
			transform: rotate(0turn);
		}
		to {
			transform: rotate(1turn);
		}
	}

	@-webkit-keyframes notification-pulse {
		0% {
			box-shadow: 0 0 0 0px rgba(255, 0, 0, 0.7);
		}
		100% {
			box-shadow: 0 0 0 15px rgba(255, 0, 0, 0);
		}
	}
	@keyframes notification-pulse {
		0% {
			box-shadow: 0 0 0 0px rgba(255, 0, 0, 0.7);
		}
		100% {
			box-shadow: 0 0 0 15px rgba(255, 0, 0, 0);
		}
	}
	@keyframes flagged-remark-pulse {
		0% {
			box-shadow: 0 0 0 0px rgba(255, 0, 0, 0.5);
		}
		100% {
			box-shadow: 0 0 0 30px rgba(255, 0, 0, 0);
		}
	}
	@-webkit-keyframes flagged-remark-pulse {
		0% {
			box-shadow: 0 0 0 0px rgba(255, 0, 0, 0.5);
		}
		100% {
			box-shadow: 0 0 0 30px rgba(255, 0, 0, 0);
		}
	}
	@-webkit-keyframes jump {
		0%, 100% {
			transform: translateY(2px);
		}
		50% {
			transform: translateY(-2px);
		}
	}
	@keyframes jump {
		0%, 100% {
			transform: translateY(2px);
		}
		50% {
			transform: translateY(-2px);
		}
	}
	.new-notification {
		animation: notification-pulse 1s 1;
	}
	.new-flagged-remark {
		animation: flagged-remark-pulse 1s 1;
		animation-delay: 1s;
	}
	.trafficlight--green {
		color: ${theme.trafficLightGreen};
	}
	.trafficlight--amber {
		color: ${theme.trafficLightAmber};
	}
	.trafficlight--red {
		color: ${theme.trafficLightRed};
	}
	.new-flag {
		position: relative;
		&::after {
			background-color: ${theme.trafficLightGreen};
			border-radius: 8px;
			color: ${theme.white};
			content: "New";
			font-size: 10px;
			padding: 2px 5px;
			right: 2px;
			position: absolute;
			top: 2px;
		}
		&.new-flag-flush {
			&::after {
				right: 0;
				top: 0;
			}
		}
		&.new-flag-offset {
			&::after {
				right: 0;
				top: -10px;
			}
		}
	}
	.beta-flag {
		position: relative;
		&::before {
			background-color: ${theme.trafficLightAmber};
			border-radius: 8px;
			color: ${theme.white};
			content: "Beta";
			font-size: 10px;
			padding: 2px 5px;
			right: -10px;
			position: absolute;
			top: -10px;
		}
	}
	.help-wrapper {
		position: relative;
		${HelpWrapperStyled} {
			top: -25px;
		}
	}
	.stripe-logo {
		height: 3.75em;
		position: relative;
		width: 7.5em;
		> div {
			bottom: 0;
			left: 0;
			position: absolute;
			top: 0;
			width: 100%;
		}
	}

	.crop-image .ReactCrop__crop-selection:not(.ReactCrop--no-animate .ReactCrop__crop-selection) {
		background-image: linear-gradient(to right, rgba(255, 255, 255, 0.3) 50%, rgba(68, 68, 68, 0.1) 50%),
			linear-gradient(to right, rgba(255, 255, 255, 0.3) 50%, rgba(68, 68, 68, 0.1) 50%),
			linear-gradient(to bottom, rgba(255, 255, 255, 0.3) 50%, rgba(68, 68, 68, 0.1) 50%),
			linear-gradient(to bottom, rgba(255, 255, 255, 0.3) 50%, rgba(68, 68, 68, 0.1) 50%);
		background-size: 20px 20px, 20px 20px, 20px 20px, 20px 20px;
	}

	/* Fixes issue where TinyMCE modals are hidden by react modals */
	.tox-tinymce-aux,
	.tox-dialog-wrap,
	.tox-dialog,
	.tox-silver-sink,
	.tox-dialog__header,
	.tox-dialog__body,
	.tox-dialog__footer {
		z-index: 999999 !important;
	}

	.tox-dialog-wrap__backdrop {
		z-index: 999998 !important;
	}
`;